<script lang="ts" setup>
import { nodeViewProps, NodeViewWrapper } from '@tiptap/vue-3'
import { computed, onMounted, ref } from 'vue'
import { Button } from '@/foundation/button'
import { Input } from '@/foundation/input'
import { getExampleUrl, getServiceSrc } from './embed'

const props = defineProps({
  ...nodeViewProps,
})
const originalLink = ref<string>('')

const src = computed({
  get: () => props.node.attrs.src,
  set: (value: string) => {
    originalLink.value = value
    props.updateAttributes({ src: value })
  },
})

function handleConfirm() {
  const result = getServiceSrc(props.node.attrs.service, originalLink.value)

  // 校验链接合法
  if (result.validLink && result.validId) {
    src.value = result.src
  } else {
    console.log('暂不支持')
  }
}
function handleExmaple() {
  const url = getExampleUrl(props.node.attrs.service)

  if (url) {
    const result = getServiceSrc(props.node.attrs.service, url)

    src.value = result.src
  }
}
onMounted(() => {
  originalLink.value = props.node.attrs.src
})
</script>

<template>
  <NodeViewWrapper as="section">
    <div v-if="!src" class="flex flex-row relative items-center">
      <Input v-model:model-value="originalLink" type="url" class="h-12 pr-40" autofocus placeholder="输入链接"> </Input>
      <div class="flex gap-2 absolute right-1 w-36">
        <Button variant="outline" @click="handleExmaple">示例</Button>
        <Button type="primary" @click="handleConfirm">确认</Button>
      </div>
    </div>
    <iframe v-if="src" :src="src" frameborder="0" allowfullscreen="true"></iframe>
  </NodeViewWrapper>
</template>
